import React from 'react';
import PowerRing from './PowerRing';

interface TimerRingProps {
  isActive: boolean;
  progress: number; // 0 a 1
  size?: number;
  borderWidth?: number;
  color?: string;
  /** cw = auto-on (sentido actual); ccw = auto-off (sentido contrario) */
  direction?: 'cw' | 'ccw';
}

/**
 * Anillo de progreso del timer.
 * Misma geometría/grosor/posición que el anillo ON fijo (PowerRing SVG).
 */
const TimerRing: React.FC<TimerRingProps> = ({
  isActive,
  progress,
  size = 43,
  borderWidth = 5,
  color = '#2391FF',
  direction = 'cw',
}) => {
  if (!isActive || progress >= 1) {
    return null;
  }

  return (
    <PowerRing
      size={size}
      borderWidth={borderWidth}
      color={color}
      progress={progress}
      direction={direction}
    />
  );
};

export default TimerRing;
